const MuiTable = {
    defaultProps: {
        size: 'small'
    }
};
export { MuiTable };

//# sourceMappingURL=table.js.map